import { useContext, useEffect, useState } from "react";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { setDateHelper, getBudgetPeriodDates } from "../../utils/Helper";
import moment from "moment";
import { ApiConstants } from "../../constants/ApiConstants";
import dummyImg from "../../assets/images/dummy.svg";
import chevRight from '../../assets/images/chev-right.svg'
import calLogo from "../../assets/images/calender.svg";
import DatePicker from "react-datepicker";


interface memberDetails {
    claimed_opportunity_hours: number
    final_value: number
    id: number
    name: string
    opportunity_cost_bonus: number
    total_chores_price: number
    total_hours: number
    maximum_opportunity_cost_hourse: number
    current_opportunity_hours: number
    isClaimed: boolean
    isEligiable: boolean
}

interface contributionsInputs {
    start_date: string;
    end_date: string;
    total_completed_hours: number;
    average: number;
    members: memberDetails[];
    is_finalized: number | null;
    prevRate: string;
    prevHours: string;
    prevDesc: string;
    prevClaimedUsers: any[]
}


const OpportunityReportSheet = ({ }: any) => {

    let profile: any = useContext(authContext);
    profile = profile?.data;

    const oppertunityCost = useMakeRequest();

    const [refetchData, setRefetchData] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [oppertunityCostItems, setOppertunityCostItems] = useState<contributionsInputs>(
        {
            start_date: "",
            end_date: "",
            total_completed_hours: 0,
            average: 0,
            members: [],
            is_finalized: null,
            prevRate: '0',
            prevHours: '0',
            prevDesc: "",
            prevClaimedUsers: []
        }
    );

    useEffect(() => {
        if (!oppertunityCostItems?.start_date && !oppertunityCostItems?.end_date) {
            // Calculate current month’s start date based on billingDate
            const { startDate, endDate } = getBudgetPeriodDates(
                moment().year(),
                moment().month(),
                profile?.data?.hh_member?.household?.billing_date || 1
            );

            // ✅ set state so UI shows dates
            setOppertunityCostItems({
                ...oppertunityCostItems,
                start_date: startDate,
                end_date: endDate,
            });

            // ✅ also set current month name
            setSelectedMonth(moment().format("MMMM"));

            oppertunityCost.makeRequest({
                url: ApiConstants?.OppertunityCostCheck,
                payload: {
                    month: moment().month(),
                    start_date: startDate,
                    end_date: endDate,
                },
            })
        }
    }, []); // only run once at mount


    useEffect(() => {
        if (oppertunityCost?.status) {
            console.log("oppertunityCost?.data?.data?.total?.previousUserEnteredHours: ", oppertunityCost?.data?.data?.total)
            setOppertunityCostItems({
                start_date: oppertunityCost?.data?.data?.total?.start_date,
                end_date: oppertunityCost?.data?.data?.total?.end_date,
                total_completed_hours: oppertunityCost?.data?.data?.total?.total_completed_hours || 0,
                prevRate: oppertunityCost?.data?.data?.total?.previousClaimedRate || 0,
                prevHours: oppertunityCost?.data?.data?.total?.previousUserEnteredHours || 0,
                prevDesc: oppertunityCost?.data?.data?.total?.previousDescription || "",
                average: oppertunityCost?.data?.data?.total?.average || 0,
                members: oppertunityCost?.data?.data?.members || [],
                is_finalized: oppertunityCost?.data?.data?.total?.is_finalized,
                prevClaimedUsers: oppertunityCost?.data?.data?.total?.previousClaimsDetails
            })

        }

    }, [oppertunityCost?.status])

    const filterderdClaimedMembers = oppertunityCostItems?.members?.filter(
        (item: memberDetails) => item.isClaimed
    );


    return (

        <div className="modal fade bottom-sheet-modal" id="opportunityCostReportModal" tabIndex={-1} aria-labelledby="opportunityCostReportLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true" >
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="opportunityCostReportModal">Opportunity Costs</h1>
                    </div>
                    <div className="modal-body">
                        <div className="page-padding-x">
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">Select Budget Period</label>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const modal: any = $("#selectDateModalOppertunityCost");
                                            modal.modal("show");
                                        }}
                                        className=" mb-2 date-modal-btn"
                                    >
                                        {selectedMonth}
                                        <img
                                            className="up-down-arw"
                                            src={chevRight}
                                            alt=""
                                        />
                                    </button>
                                </div>
                            </div>
                            <div className="row mb-4 pt-3">
                                <div className="col-6">
                                    <div className="com-input-grp disabled-input-grp">
                                        <label className="form-label">Start Date</label>
                                        <DatePicker
                                            className="form-control"
                                            placeholderText="MM/DD/YYYY"
                                            timeFormat="MM DD YYYY"
                                            onKeyDown={(e: any) => e.preventDefault()}
                                            showYearDropdown
                                            scrollableYearDropdown
                                            yearDropdownItemNumber={50}
                                            disabled
                                            selected={oppertunityCostItems?.start_date as any}
                                            showIcon
                                            icon={
                                                <>
                                                    <img className="calIcon" src={calLogo} alt="" />
                                                </>
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="com-input-grp disabled-input-grp">
                                        <label className="form-label">End Date</label>
                                        <DatePicker
                                            className="form-control"
                                            placeholderText="MM/DD/YYYY"
                                            timeFormat="MM DD YYYY"
                                            onKeyDown={(e: any) => e.preventDefault()}
                                            showYearDropdown
                                            scrollableYearDropdown
                                            yearDropdownItemNumber={50}
                                            disabled
                                            selected={oppertunityCostItems?.end_date as any}
                                            showIcon
                                            icon={
                                                <>
                                                    <img className="calIcon" src={calLogo} alt="" />
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className='cost-info-box'>
                                        <div className='info-row'>
                                            <span className='info-label'>Completed Hours of Chores</span>
                                            <span className='info-value'>{oppertunityCostItems.total_completed_hours}</span>
                                        </div>
                                        <div className='info-row'>
                                            <span className='info-label'>Average</span>
                                            <span className='info-value'>{Number(oppertunityCostItems.average).toFixed(2)}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* {oppertunityCostItems?.members
                                    ?.filter((m) => m.isEligiable) // ✅ Only eligible members
                                    .map((member) => {
                                        const isCurrentUser = member.id === profile?.data?.id;
                                        const prev = preveClaimedUsers.find((p) => p.member_id === member.id);
                                        return (
                                            <div className="member-details-card" key={member.id}>
                                                <div className="member-card-head">
                                                    <img src={dummyImg} alt="" />
                                                    <span className="member-card-name">{member.name}</span>
                                                </div>

                                                <div className="member-card-body">
                                                    <div className="row gy-2">
                                                        <div className="member-card-item-header">
                                                            <div className="member-card-item-label">Hours of Chores</div>
                                                            <div className="member-card-item-value">{member.total_hours}</div>
                                                        </div>
                                                        <div className="member-card-item-header">
                                                            <div className="member-card-item-label">Maximum Opportunity-Cost Hours</div>
                                                            <div className="member-card-item-value">{Number(member.maximum_opportunity_cost_hourse).toFixed(2)}</div>
                                                        </div>
                                                        <div className="member-card-item-header">
                                                            <div className="member-card-item-label">Current Opportunity-cost Hours</div>
                                                            <div className="member-card-item-value">{Number(member?.current_opportunity_hours || 0).toFixed(2)}</div>
                                                        </div>

                                                        {isCurrentUser ? (
                                                            // ✅ Editable Form for current user
                                                            <form
                                                                onSubmit={handleSubmit((form) => onSubmit(form, member.maximum_opportunity_cost_hourse))}
                                                                className="auth-form-wrap">
                                                                <div className="my-3 com-input-grp">
                                                                    <label>Hours Claimed</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Hours"
                                                                        {...register("claim_hours", {
                                                                            required: ValidationMessage.CLAIMED_HOURS,
                                                                            // validate: (value) => {
                                                                            //   const maxHours = member?.maximum_opportunity_cost_hourse;
                                                                            //   const input = parseFloat(parseFloat(value).toFixed(2));
                                                                            //   const max = parseFloat(Number(maxHours).toFixed(2));
                                                                            //   if (value && input > max) {
                                                                            //     return `Cannot exceed ${max.toFixed(2)} hours.`;
                                                                            //   }
                                                                            //   return true;
                                                                            // },
                                                                        })}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        name="claim_hours"
                                                                        render={({ message }) => <p className="valid-error">{message}</p>}
                                                                    />
                                                                </div>

                                                                <div className="mb-3 com-input-grp">
                                                                    <label>Rate</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Rate"
                                                                        {...register("rate", { required: ValidationMessage.RATE })}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        name="rate"
                                                                        render={({ message }) => <p className="valid-error">{message}</p>}
                                                                    />
                                                                </div>

                                                                <div className="mb-3 com-input-grp">
                                                                    <label>Description</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Description"
                                                                        {...register("description", { required: ValidationMessage.DESCRIPTION })}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        name="description"
                                                                        render={({ message }) => <p className="valid-error">{message}</p>}
                                                                    />
                                                                </div>

                                                                <Button
                                                                    className="com-btn"
                                                                    type="submit"
                                                                    loading={claimOppertunityCost?.loading}
                                                                >
                                                                    Save
                                                                </Button>
                                                            </form>
                                                        ) : (
                                                            // ❌ Read-only view for other eligible members
                                                            <div className="auth-form-wrap mt-3">
                                                                <div className="mb-3 com-input-grp">
                                                                    <label>Hours Claimed</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={prev?.previousClaimedHours ?? "0"}
                                                                        disabled
                                                                    />
                                                                </div>

                                                                <div className="mb-3 com-input-grp">
                                                                    <label>Rate</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={prev?.previousClaimedRate ?? "0"}
                                                                        disabled
                                                                    />
                                                                </div>

                                                                <div className="mb-3 com-input-grp">
                                                                    <label>Description</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={prev?.previousDescription ?? ""}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })} */}

                                {filterderdClaimedMembers?.length > 0 && filterderdClaimedMembers.map((member: memberDetails) => (
                                    <div className="member-details-card" key={member.id}>
                                        <div className="member-card-head">
                                            <img src={dummyImg} alt="" />
                                            <span>{member.name}</span>
                                        </div>
                                        <div className="member-card-body">
                                            <div className="row gy-2">
                                                <div className="member-card-item-header">
                                                    <div className="member-card-item-label">Hours of Chores</div>
                                                    <div className="member-card-item-value">{member.total_hours}</div>
                                                </div>
                                                <div className="member-card-item-header">
                                                    <div className="member-card-item-label">Maximum Opportunity-Cost Hours</div>
                                                    <div className="member-card-item-value">{Number(member.maximum_opportunity_cost_hourse).toFixed(2)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OpportunityReportSheet